<div [ngClass]="cssClass" class="database_contact_status segmentation_contact" *ngIf="model && model.Result && model.Result.length>0">
  <div class="row">
    <div class="col-md-3 col-xl-2 pe-5"><span class="data">{{model.Result[0].Total | number}}</span> {{titleTotal}}</div>
    <div class="col-md-6 col-xl-4">
      <div class="row segmentation_contact_roles">
        <div class="col"><span class="data">{{model.Result[0].R2 | number}}</span> <span class="role r2">R2</span></div>
        <div class="col"><span class="data">{{model.Result[0].R3 | number}}</span> <span class="role r3">R3</span></div>
        <div class="col"><span class="data">{{model.Result[0].Motrio | number}}</span> <span class="role motrio">Motrio</span></div>
      </div>
    </div>
    <div class="col">
      <div class="row float-end">
        <div *ngIf="showImpacted" class="col-auto"><span class="data">{{model.Result[0].Impacted | number}}</span> Impactados recientemente</div>
        <div class="col-auto"><span class="data">{{model.Result[0].Stopcom | number}}</span> Con baja de comunicaciones</div>
      </div>
    </div>
  </div>
  <div *ngIf="showAvailable || showSelected" class="row total-contacts">
    <div *ngIf="showAvailable" class="col-md-3 col-xl-2 pe-5"><span class="data">{{model.Result[0].TotalAvailable | number}}</span> Total disponible</div>
    <div *ngIf="showSelected" class="col"><span class="data">{{selected | number}}</span> Total seleccionado</div>
  </div>
</div>